import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { commentPreBuiltLimitedCartSave } from 'swag-client-common/redux/cart/cart.actions';
import { cartItemsSelector } from 'swag-client-common/redux/cart/cart.selectors';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isCommentPreBuiltLimitedCartPopupShownSelector, popupParamsSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { getDefaultImageFromItem } from 'swag-common/utils/items/get-default-image-from-item.util';
import { CommentPreBuiltLimitedCartPopupComponent as Component } from './comment-pre-built-limited-cart';
const itemIdSelector = createSelector(popupParamsSelector, params => params.itemId);
const isProductCommentSelector = createSelector(itemIdSelector, itemId => Boolean(itemId));
const itemSelector = createSelector(itemIdSelector, cartItemsSelector, (itemId, items) => {
  var _items$find;
  return (_items$find = items === null || items === void 0 ? void 0 : items.find(({
    _id
  }) => _id === itemId)) !== null && _items$find !== void 0 ? _items$find : {};
});
const productImageUrlSelector = createSelector(itemSelector, item => {
  return getDefaultImageFromItem(item);
});
const productNameSelector = createSelector(itemSelector, item => {
  var _item$prod;
  return (_item$prod = item.prod) === null || _item$prod === void 0 ? void 0 : _item$prod.name;
});
export const storeNameSelector = () => {
  const {
    swag: {
      storeSettings
    }
  } = window;
  return storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.storeName;
};
const mapStateToProps = createStructuredSelector({
  open: isCommentPreBuiltLimitedCartPopupShownSelector,
  isProductComment: isProductCommentSelector,
  productImageUrl: productImageUrlSelector,
  productName: productNameSelector,
  itemId: itemIdSelector,
  storeName: storeNameSelector
});
const mapDispatchToProps = dispatch => ({
  onSendMessage: (note, itemId) => {
    dispatch(commentPreBuiltLimitedCartSave({
      note,
      itemId
    }));
  },
  onClose: () => {
    dispatch(hidePopup());
  }
});
export const CommentPreBuiltLimitedCartPopup = connect(mapStateToProps, mapDispatchToProps)(Component);